(ns frontend.ux-overhaul.listing.oppo.view
  (:require [frontend.state.current-session :as session]))

(def config
  {:listing-id               "oppo-listing"
   :entity-type              :entity.type/oppo
   :route-id                 :oppos-grid
   :create-action-id         :create-oppo
   :create-label             :deal-add-button
   :pipeline-attribute       :oppo/pipeline
   :pipeline-key             :oppo-pipeline
   :module                   :module/dealflow
   :route-with-pipeline-id   :oppos-grid-with-pipeline
   :stage-entity-type        :entity.type/stage
   :stage-name-attribute     :stage/name
   :stage-pipeline-attribute :stage/pipeline
   :title                    :deals
   :selected-pipeline        session/selected-oppo-pipeline
   :all-pipelines            session/all-oppo-pipelines
   :feature?                 session/dealflow?})
